import { useTheme } from './ThemeContext';

export function useTableStyles() {
  const { theme } = useTheme();

  const muiTableBodyCellSx = {
    fontWeight: 'normal',
    fontSize: '12px',
    padding: '4px 8px',
    boxSizing: 'border-box',
    ...(theme.muiOverride ? { color: theme.bodyText } : {}),
  };

  const muiTableHeadCellSx = {
    fontSize: '12px',
    backgroundColor: theme.primary,
    color: '#fff',
    padding: '4px 8px',
    boxSizing: 'border-box',
    '& .MuiTableSortLabel-icon': { color: '#fff !important' },
    '& .MuiTableSortLabel-root': { color: '#fff !important' },
    '& .MuiTableSortLabel-root.Mui-active': { color: '#fff !important' },
    '& .MuiTableSortLabel-root:hover': { color: '#fff !important' },
    '& .MuiIconButton-root': { color: '#fff !important' },
    '& .MuiIconButton-root:hover': { color: '#fff !important' },
    '& svg': { color: '#fff !important', fill: '#fff !important' },
  };

  const muiPaginationSx = {
    fontSize: '12px',
    backgroundColor: theme.primary,
    color: '#fff',
  };

  const panelBackgroundColor = theme.panelBg;

  const tableBackground = theme.muiOverride ? theme.panelBg : undefined;
  const muiTablePaperSx = tableBackground ? { backgroundColor: tableBackground } : {};
  const muiTopToolbarSx = tableBackground ? { backgroundColor: tableBackground } : {};
  const muiBottomToolbarSx = tableBackground ? { backgroundColor: tableBackground } : {};

  const defaultTableConfig = {
    muiTableBodyCellProps: { sx: muiTableBodyCellSx },
    muiTableHeadCellProps: { sx: muiTableHeadCellSx },
    muiTablePaperProps: { sx: muiTablePaperSx },
    muiTopToolbarProps: { sx: muiTopToolbarSx },
    muiBottomToolbarProps: { sx: muiBottomToolbarSx },
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    layoutMode: 'grid',
  };

  const compactTableConfig = {
    muiTableBodyCellProps: { sx: muiTableBodyCellSx },
    muiTableHeadCellProps: { sx: muiTableHeadCellSx },
    muiTablePaperProps: { sx: muiTablePaperSx },
    muiTopToolbarProps: { sx: muiTopToolbarSx },
    muiBottomToolbarProps: { sx: muiBottomToolbarSx },
    initialState: {
      density: 'compact',
    },
    layoutMode: 'grid',
  };

  const wideTableConfig = {
    muiTableBodyCellProps: { sx: muiTableBodyCellSx },
    muiTableHeadCellProps: { sx: muiTableHeadCellSx },
    muiTablePaperProps: { sx: muiTablePaperSx },
    muiTopToolbarProps: { sx: muiTopToolbarSx },
    muiBottomToolbarProps: { sx: muiBottomToolbarSx },
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    layoutMode: 'grid-no-grow',
  };

  return {
    muiTableBodyCellSx,
    muiTableHeadCellSx,
    muiPaginationSx,
    panelBackgroundColor,
    muiTablePaperSx,
    muiTopToolbarSx,
    muiBottomToolbarSx,
    defaultTableConfig,
    compactTableConfig,
    wideTableConfig,
  };
}
